export default "__VITE_ASSET__DlwER_xG__"